import TenantComponents from '@components';

export const Health = (props) => {
  return <TenantComponents.Health {...props} />;
};
